import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: () => import("../components/homePage.vue"),
      meta: {
        title: "首页",
      },
    },
    {
      path: "/index/PageBlank",
      name: "PageBlank",
      component: () => import("../components/blank/index.vue"),
      meta: {
        title: "空白",
      },
    },
    {
      path: "/aboutUs",
      component: () => import("../components/aboutUs/index.vue"),
      meta: {
        title: "关于我们",
      },
    },
    {
      path: "/productsAndServices",
      component: () => import("../components/productsAndServices/index.vue"),
      meta: {
        title: "产品服务",
      },
    },
    {
      path: "/solution",
      component: () => import("../components/solution/index.vue"),
      meta: {
        title: "产品中心",
      },
    },
    {
      path: "/contactUs",
      component: () => import("../components/contactUs/index.vue"),
      meta: {
        title: "联系我们",
      },
    },
    {
      path: "/login",
      component: () => import("../components/login/index.vue"),
      meta: {
        title: "登录",
      },
    },
    // {
    //   path: "/activity",
    //   component: () => import("../components/Activity.vue"),
    //   meta: {
    //     title: "默认页面-首页",
    //     requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    //   },
    //   redirect: "/homePage", //该配置是若点击选中父目录时，默认选中该目录下的子路经页面
    //   children: [
    //     {
    //       path: "/homePage",
    //       // name: 'css',
    //       component: () => import("../components/embedded/homePage.vue"),
    //       meta: {
    //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    //         title: "首页"
    //       }
    //     }
    //   ]
    // }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js